/* eslint-disable import/no-unused-modules */
import React from 'react';
import { communityIdList } from 'tf-post-parser';
import Community from '../../components/Community/Community';
import { callBridge } from '../../helpers/hive';
import withApollo from '../../lib/withApollo';

const CommunityPage = ({ community }) => {
  return <Community community={community} />;
};

export async function getStaticProps({ params }) {
  const { community } = params;

  try {
    const getCommunity = await callBridge('get_community', {
      name: `hive-${community}`,
      observer: 'travelfeed',
    });
    if (!getCommunity || !getCommunity.id)
      return { notFound: true, revalidate: 10 };
    return { props: { community: getCommunity }, revalidate: 60 };
  } catch {
    return { notFound: true, revalidate: 10 };
  }
}

export async function getStaticPaths() {
  const paths = [];
  communityIdList.forEach(community =>
    paths.push({ params: { community: JSON.stringify(community) } }),
  );
  return { paths, fallback: false };
}

export default withApollo(CommunityPage);
